import generalSection from "../_section/section.class";
import {userCreditReportUpload, adminCreditReportUpload} from "./upload";
import DataForm from "./DataForm";

export class userCreditReportSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userCreditReportUpload);
        // Add missing date error

    }
}

export class adminCreditReportSection extends userCreditReportSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminCreditReportUpload);
        this.DataForm = DataForm
        this.sortByDateProp('documentDate');
        this.activeUpload = this.uploads.find(u => u.allValuesAnswered && u.isVerifiable)
        this.activeUploads = this.uploads.filter(upload => upload.isActive)
        this.setProblems(this.problemsList.singleUploadUserProblems())
    }
    getSectionSummary = () => {
        return [
            {
                name: this.personalTitle,
                tags:[{
                    name: 'Dated',
                    value: this.values?.documentDate?.format('D MMM YYYY') || 'Not Provided',
                }]
            }
        ]
    }
}